import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { useFeature } from '@growthbook/growthbook-react'
import { BookingContext } from 'contexts/booking'
import { Rating, saveClassResult, adaptStudentResult } from 'api/unit-assessment'
import { AssessmentContext, StudentWithScores } from 'contexts/assessment'
import { ASSESSMENT_RECOMMENDATIONS_FEATURE_FLAG, AssessmentStatus, BookingStatus } from 'utils/constants'
import { SavingCallbacks } from './useSavingStatus'

export type Score = {
    student: StudentWithScores
    rating: Rating
    value: number
}

export const useSaveScore = (saving: () => SavingCallbacks): [Score | undefined, Dispatch<SetStateAction<Score | undefined>>] => {
    const assessment = useContext(AssessmentContext)
    const booking = useContext(BookingContext)
    const isAssessmentRecommendationsEnabled = useFeature(ASSESSMENT_RECOMMENDATIONS_FEATURE_FLAG).value === true

    const [score, setScore] = useState<Score>()

    useEffect(() => {
        if (score && booking.status === BookingStatus.VALIDATED && assessment.status === AssessmentStatus.ENCOUNTER) {
            score.student.scores.set(score.rating.id, score.value)

            const [done, error] = saving()
            saveClassResult(
                booking.auth,
                assessment.classDetails.classId,
                adaptStudentResult(score.student, false, isAssessmentRecommendationsEnabled)
            )
                .then(done)
                .catch(e => {
                    score.student.scores.delete(score.rating.id)
                    score.student.finalScore = void 0
                    error(e)
                })

            setScore(void 0)
        }
    }, [score, isAssessmentRecommendationsEnabled])

    return [score, setScore]
}
